var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define(["require", "exports", "../services/toastNotification", "./modal"], function (require, exports, toastNotification_1, modal_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.UploadModal = void 0;
    var UploadModal = (function () {
        function UploadModal() {
            var _this = this;
            this._modalConfig = {
                btnCancelar: '#upload-modal-buttons-cancelar',
                btnConfirmar: '#upload-modal-buttons-confirmar',
                modalHeader: '#upload-modal-header',
                modalBody: '#upload-modal-body',
                modalClose: '#upload-modal-close',
                modal: '#upload-modal'
            };
            this._disabledClassesForButton = ['bg-linx-purple-transparent-100', 'wl-autosservico-btn', 'cursor-not-allowed', 'shadow'];
            this._enabledClassesForButton = ['bg-linx-purple-1100', 'wl-autosservico-btn', 'cursor-pointer', 'hover:bg-linx-purple-1200'];
            this._spanClasses = ['block', 'text-gray-600'];
            this._filenameClass = 'upload-filename';
            this._divItemClass = 'upload-item';
            this._fileKeyAttr = 'data-file-index';
            this._signatureIdAttr = 'data-signature-id';
            this._removeFileClass = 'remove-file';
            this._maxUploadCountSpanId = 'spn-max-upload-count';
            this._maxUploadSizeSpanId = 'spn-max-upload-size';
            this.GetDropArea = function () { return document.querySelector('#upload-modal-body-right'); };
            this.GetHiddenInput = function () { return document.querySelector('#upload-hidden-input'); };
            this.GetDivFileList = function () { return document.querySelector('#upload-modal-uploaded-files'); };
            this.GetBtnConfirm = function () { return document.querySelector(_this._modalConfig.btnConfirmar); };
            this.GetCbxUpload = function () { return document.getElementById('toggle-upload'); };
            this.GetSpanMaxUploadCount = function () { return document.getElementById(_this._maxUploadCountSpanId); };
            this.GetSpanMaxUploadSize = function () { return document.getElementById(_this._maxUploadSizeSpanId); };
            this._fileKey = 0;
            this.fileList = new Map();
            this.maxCount = 0;
            this.maxSize = 0;
            this._modal = new modal_1.Modal(this._modalConfig.modal, this._modalConfig);
            this._spanNoFiles = document.createElement('span');
            this.Start();
        }
        UploadModal.prototype.Start = function () {
            return __awaiter(this, void 0, void 0, function () {
                var cbx, btnConfirm;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this._spanNoFiles.innerText = 'Nenhum arquivo enviado';
                            this._spanNoFiles.classList.add('text-center');
                            this._spanClasses.forEach(function (c) { return _this._spanNoFiles.classList.add(c); });
                            cbx = this.GetCbxUpload();
                            if (!cbx)
                                return [2];
                            this.AddCheckboxEvent();
                            this.AddDropAreaEvents();
                            return [4, this.SetSpanMaxUpload()];
                        case 1:
                            _a.sent();
                            this._modal.AddHeaderMessage('Enviar documentos')
                                .AddConfirmButton(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (this.fileList.size > this.maxCount) {
                                                toastNotification_1.ToastNotification.Alert("N\u00E3o \u00E9 poss\u00EDvel enviar mais do que " + this.maxCount + " arquivos.", 10000);
                                                this.fileList = new Map();
                                                this.GetDivFileList().innerHTML = '';
                                            }
                                            if (!(this._onConfirmClick != null)) return [3, 2];
                                            return [4, this._onConfirmClick()];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            this._modal.Close();
                                            return [2];
                                    }
                                });
                            }); }, 'Confirmar')
                                .Show('flex');
                            btnConfirm = this.GetBtnConfirm();
                            if (!btnConfirm)
                                return [2];
                            btnConfirm.disabled = true;
                            this.TryToggleConfirm();
                            return [2];
                    }
                });
            });
        };
        UploadModal.prototype.addOnConfirmClick = function (func) {
            this._onConfirmClick = func;
        };
        UploadModal.prototype.AddCheckboxEvent = function () {
            var _this = this;
            this.TryToggleConfirm();
            var cbxUpload = this.GetCbxUpload();
            if (!cbxUpload)
                return;
            cbxUpload.onchange = function () { return _this.TryToggleConfirm(); };
        };
        UploadModal.prototype.AddDropAreaEvents = function () {
            var _this = this;
            var _a, _b, _c;
            var dropArea = this.GetDropArea();
            if (!dropArea)
                return;
            dropArea.replaceWith(dropArea.cloneNode(true));
            Array.from(['dragenter', 'dragover']).forEach(function (eventName) {
                var _a;
                var event = function () { var _a; return (_a = _this.GetDropArea()) === null || _a === void 0 ? void 0 : _a.classList.add('bg-gray-600'); };
                (_a = _this.GetDropArea()) === null || _a === void 0 ? void 0 : _a.addEventListener(eventName, event, false);
            });
            Array.from(['dragleave', 'drop']).forEach(function (eventName) {
                var _a;
                var event = function () { var _a; return (_a = _this.GetDropArea()) === null || _a === void 0 ? void 0 : _a.classList.remove('bg-gray-600'); };
                (_a = _this.GetDropArea()) === null || _a === void 0 ? void 0 : _a.addEventListener(eventName, event, false);
            });
            Array.from(['dragenter', 'dragover', 'dragleave']).forEach(function (eventName) {
                var _a;
                var event = function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                };
                (_a = _this.GetDropArea()) === null || _a === void 0 ? void 0 : _a.addEventListener(eventName, event, false);
            });
            var dragEvent = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var files;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            e.preventDefault();
                            e.stopPropagation();
                            files = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files;
                            if (!files)
                                return [2];
                            return [4, this.AddFiles(files)];
                        case 1:
                            _b.sent();
                            return [2];
                    }
                });
            }); };
            (_a = this.GetDropArea()) === null || _a === void 0 ? void 0 : _a.addEventListener('drop', dragEvent);
            (_b = this.GetDropArea()) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () { var _a; return (_a = _this.GetHiddenInput()) === null || _a === void 0 ? void 0 : _a.click(); });
            (_c = this.GetHiddenInput()) === null || _c === void 0 ? void 0 : _c.addEventListener('change', function (e) { return __awaiter(_this, void 0, void 0, function () {
                var target, files;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            target = e.target;
                            files = target.files;
                            if (!files)
                                return [2];
                            return [4, this.AddFiles(files)];
                        case 1:
                            _b.sent();
                            try {
                                target.value = '';
                            }
                            finally {
                                if (target.value)
                                    (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.replaceChild(target.cloneNode(true), target);
                            }
                            return [2];
                    }
                });
            }); });
        };
        UploadModal.prototype.AddFiles = function (fileList) {
            return __awaiter(this, void 0, void 0, function () {
                var i;
                return __generator(this, function (_a) {
                    for (i = 0; i < fileList.length; i++)
                        this.AddFile(fileList[i]);
                    return [2];
                });
            });
        };
        UploadModal.prototype.AddFile = function (file) {
            return __awaiter(this, void 0, void 0, function () {
                var divFileList, maxSizeBytes, key, divItem;
                return __generator(this, function (_a) {
                    divFileList = this.GetDivFileList();
                    if (!divFileList)
                        return [2, Promise.resolve(false)];
                    if (!file.type.includes('image') && !file.type.includes('pdf')) {
                        toastNotification_1.ToastNotification.Alert('O arquivo enviado deve ser uma imagem ou um documento de extensão .pdf', 10000);
                        return [2, Promise.resolve(false)];
                    }
                    maxSizeBytes = this.maxSize * 1024 * 1024;
                    if (file.size > maxSizeBytes) {
                        toastNotification_1.ToastNotification.Alert("O arquivo " + file.name + " excede " + this.maxSize + "MB.", 10000);
                        return [2, Promise.resolve(false)];
                    }
                    key = this.GetNewKey();
                    this.fileList.set(key, file);
                    this._spanNoFiles.classList.add('hidden');
                    divItem = this.BuildGridItem(file.name, key);
                    divFileList.prepend(divItem);
                    this.TryToggleConfirm();
                    return [2, Promise.resolve(true)];
                });
            });
        };
        UploadModal.prototype.BuildGridItem = function (filename, key) {
            var _this = this;
            var div = document.createElement('div');
            div.classList.add('block');
            div.classList.add('w-full');
            div.classList.add('py-3');
            div.classList.add("" + this._divItemClass);
            div.setAttribute(this._fileKeyAttr, "" + key);
            var filenameSpanContent = filename;
            div.innerHTML = "<div class=\"grid grid-cols-12 gap-4 items-center px-2 overflow-hidden\">\n                                <div class=\"flex col-span-10\">                               \n                                    <span class=\"" + this._filenameClass + " text-sm truncate\" title=\"" + filename + "\">" + filenameSpanContent + "</span>                                \n                                </div>\n                                <div class=\"flex justify-end col-span-2 items-center\">\n                                    <button " + this._fileKeyAttr + "=\"" + key + "\" class=\"" + this._removeFileClass + " flex items-center justify-center mx-1 text-2xl\">\n                                        &times;\n                                    </button>\n                                </div>\n                             </div>";
            var btnRemove = (div.getElementsByClassName(this._removeFileClass)[0]);
            btnRemove.addEventListener('click', function (e) {
                _this.HandleRemoveClickEvent(e);
            });
            return div;
        };
        UploadModal.prototype.GetNewKey = function () {
            var res = this._fileKey;
            this._fileKey++;
            return res;
        };
        UploadModal.prototype.GetUploadedItemDivByKey = function (index) {
            var _a;
            var divFileList = this.GetDivFileList();
            return (_a = divFileList === null || divFileList === void 0 ? void 0 : divFileList.querySelector("div[" + this._fileKeyAttr + "=\"" + index + "\"]")) !== null && _a !== void 0 ? _a : null;
        };
        UploadModal.prototype.HandleRemoveClickEvent = function (event) {
            return __awaiter(this, void 0, void 0, function () {
                var btn, keyS, key;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            btn = event.target;
                            keyS = btn.getAttribute(this._fileKeyAttr);
                            if (keyS == null)
                                return [2];
                            key = Number(keyS);
                            return [4, this.HandleRemoveClick(key)];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        UploadModal.prototype.HandleRemoveClick = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var divFileList, parentDiv, removeFromModal, removeFile;
                var _this = this;
                return __generator(this, function (_a) {
                    divFileList = this.GetDivFileList();
                    if (!divFileList)
                        return [2];
                    parentDiv = this.GetUploadedItemDivByKey(key);
                    removeFromModal = function () {
                        _this.fileList.delete(key);
                        parentDiv === null || parentDiv === void 0 ? void 0 : parentDiv.remove();
                    };
                    removeFile = function () {
                        removeFromModal();
                        var count = divFileList.querySelectorAll('div').length;
                        if (count === 0)
                            _this._spanNoFiles.classList.remove('hidden');
                        _this.TryToggleConfirm();
                    };
                    removeFile();
                    return [2];
                });
            });
        };
        UploadModal.prototype.SetSpanMaxUpload = function () {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var count, size;
                return __generator(this, function (_c) {
                    count = this.GetSpanMaxUploadCount();
                    size = this.GetSpanMaxUploadSize();
                    if (!count || !size)
                        return [2];
                    this.maxCount = Number((_a = count.dataset.count) !== null && _a !== void 0 ? _a : 0);
                    this.maxSize = Number((_b = size.dataset.size) !== null && _b !== void 0 ? _b : 0);
                    count.innerText = "N\u00B0 m\u00E1ximo de arquivos: " + this.maxCount;
                    size.innerText = "Tamanho m\u00E1ximo por arquivo: " + this.maxSize + "MB";
                    return [2];
                });
            });
        };
        UploadModal.prototype.TryToggleConfirm = function () {
            var _a, _b, _c, _d;
            var divFileList = this.GetDivFileList();
            var btnConfirm = this.GetBtnConfirm();
            if (!divFileList || !btnConfirm)
                return;
            var cbxUpload = this.GetCbxUpload();
            if (!cbxUpload)
                return;
            var countItems = divFileList.querySelectorAll("div[" + this._fileKeyAttr + "]:not([" + this._signatureIdAttr + "])").length;
            var enable = cbxUpload.checked && countItems > 0;
            btnConfirm.disabled = !enable;
            if (enable) {
                (_a = btnConfirm.classList).remove.apply(_a, this._disabledClassesForButton);
                (_b = btnConfirm.classList).add.apply(_b, this._enabledClassesForButton);
                btnConfirm.removeAttribute('disabled');
            }
            else {
                (_c = btnConfirm.classList).remove.apply(_c, this._enabledClassesForButton);
                (_d = btnConfirm.classList).add.apply(_d, this._disabledClassesForButton);
                btnConfirm.setAttribute('disabled', 'disabled');
            }
        };
        return UploadModal;
    }());
    exports.UploadModal = UploadModal;
});
